export default {
  batch_ops: {
    operations: [{
      method: 'String',
      path: 'String',
      params: 'Object',
      body: 'String',
      operation_id: 'String',
    }],
  },
  webhook: {
    url: 'String',
  },
}
